import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Redirect from "./Redirect";
import Login from "../pages/Login";
import { superAdminRoutes } from "../superAdmin/SuperAdminRoutes";
import Header from "../components/header/Header";
import { useSelector } from "react-redux";
import SideMenu from "../components/sideMenu/SideMenu";
import { Grid, useMediaQuery } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import Loader from "../components/common/loader/Loader";
import Toast from "../components/common/Toast";
import axios from "axios";
import AccountActivate from "../superAdmin/pages/AccountActivate";
import AccountResetPassword from "../superAdmin/pages/AccountResetPassword";
import { CustomerRoutes } from "../customerAdmin/CustomerRoutes";
import ForgetPassword from "../pages/ForgetPassword";
import SystemMaintenance from "../pages/SystemMaintenance";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import PaymentSuccess from "../pages/PaymentSuccess";
import Signup from "../pages/Signup";
import AccountVerify from "../pages/AccountVerify";
import PlanList from "../pages/PlanList";
import { useDispatch } from "react-redux";
import { getMaintenanceScreenAction } from "../store/reducers/publicSlice";
import PaymentInfo from "../pages/PaymentInfo";
import { setNextActionUpdated } from "../store/reducers/adminCreationSlice";
import CustomerFeedbackUrl from "../pages/CustomerFeedbackUrl";
import CustomerOtpLoginPage from "../customerAdmin/pages/CustomerOtpLoginPage";

// Extend the Window interface to include Tawk_API
declare global {
  interface Window {
    Tawk_API?: {
      setAttributes?: (
        attributes: { name: string; email: string },
        callback?: (error?: any) => void
      ) => void;
      [key: string]: any;
    };
  }
}

const AppRoutes = () => {
  const { isLoggedIn, user } = useSelector((state: any) => state?.user);
  const { nextActionUpdated } = useSelector(
    (state: any) => state.adminCreation
  );

  const { isMaintenanceScreen } = useSelector((state: any) => state.public);
  const dispatch = useDispatch();
  const { isAdmin, isCustomer } = useMemo(() => {
    const roles = user?.user?.roles || [];
    if (roles.includes("Customer") || roles.includes("CUSTOMER")) {
      return { isAdmin: false, isCustomer: true as any };
    } else if (roles.includes("TENANT") || roles.includes("Admin")) {
      return { isAdmin: true, isCustomer: false as any };
    } else if (roles.includes('Surveyor') || roles.includes('SURVEYOR')) {
      return { isAdmin: false, isCustomer: false as any };
    }
    return { isAdmin: true, isCustomer: false as any };
  }, [user]);
  const isSmallScreen = useMediaQuery("(max-width:1240px)");
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    if (isSmallScreen) {
      setShowSidebar(!isSmallScreen);
    }
  }, [isSmallScreen]);

  const toggleSidebar = () => {
    setShowSidebar((prevState) => !prevState);
  };

  useEffect(() => {
    if (dispatch) {
      dispatch(getMaintenanceScreenAction());
    }
  }, [dispatch]);

  console.log("user roles-", user);

  // useEffect(() => {
  const userDetail: any = localStorage.getItem("user");
  if (user?.accessToken) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + user?.accessToken;
  } else if (userDetail) {
    const userDetailParse = JSON.parse(userDetail);
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + userDetailParse?.accessToken;
  }

  const [isNextAction, setIsNextAction] = useState(null);

  useEffect(() => {
    if (user) {
      if (
        user?.user?.roles?.includes("TENANT") ||
        user?.user?.roles?.includes("Admin") ||
        user?.user?.roles?.includes("Owner") ||
        !(
          user?.user?.roles?.length === 1 &&
          (user?.user?.roles[0] === "Surveyor" ||
            user?.user?.roles[0] === "CUSTOMER")
        )
      ) {
        setShowSidebar(true);
      } else {
        setShowSidebar(false);
      }
      const nextAction = JSON.parse(localStorage.getItem("nextAction") || '""');
      setIsNextAction(nextAction);
      if (nextAction === "dashboard") {
        dispatch(setNextActionUpdated(false));
      }
    }
  }, [user, nextActionUpdated]);

  const tawkMessengerRef: any = useRef();
  const onLoad = () => {
    if (tawkMessengerRef?.current?.getWindowType() === "inline") {
      // do something if it's inline
    } else {
      // do something if it's embed
    }
  };

  // const onLoad = () => {
  //   const windowType = tawkMessengerRef?.current?.getWindowType();
  //   console.log(`Tawk loaded in ${windowType} mode`);

  //   const name = user?.user?.name || "";
  //   const email = user?.user?.email || "";

  //   if (window?.Tawk_API?.setAttributes) {
  //     window.Tawk_API.setAttributes(
  //       {
  //         name,
  //         email
  //       },
  //       (error) => {
  //         if (error) {
  //           console.error("Tawk setAttributes error:", error);
  //         }
  //       }
  //     );
  //   }
  // };

  return (
    <>
      {isMaintenanceScreen?.website_mode === "MAINTENANCE" ? (
        <>
          <SystemMaintenance />
        </>
      ) : (
        <>
          <Router>
            <Loader />
            <Toast />
            {user?.idToken &&
              ((user?.user?.email_verified === "true" || user?.user?.email_verified === true) &&
                (user?.user?.hasOwnProperty("is_password_change_required")
                  ? user?.user?.is_password_change_required === false
                  : true)
              ) &&
              isNextAction === "dashboard" && (
                <Header toggleSidebar={toggleSidebar} />
              )}
            <Grid container sx={{ minHeight: "100vh", width: "100%", background: "#f4f4f4", margin: 0 }}>
              <Grid
                item
                xs={1}
                sm={1}
                sx={{
                  background: "#f3f3f3",
                  marginTop: "-8px",
                  zIndex: 99,
                  // maxWidth: "110px !important",
                  display: {
                    xs: showSidebar ? "flex" : "none",
                    sm: "flex",
                  },
                }}
              >
                {user?.idToken &&
                  user?.user?.email_verified === "true" &&
                  (user?.user?.hasOwnProperty("is_password_change_required")
                    ? user?.user?.is_password_change_required === false
                    : true) &&
                  isNextAction === "dashboard" &&
                  showSidebar && <SideMenu />}
              </Grid>
              <Grid
                item
                sx={{
                  flexGrow: 1, // take remaining space
                  minWidth: 0, // prevent overflow
                  width: showSidebar
                    ? "100% !important"
                    : "calc(100% + 110px) !important",
                  transition: "width 0.3s ease", // smooth resize
                }}
                xs={
                  user?.idToken &&
                  user?.user?.email_verified === "true" &&
                  (user?.user?.hasOwnProperty("is_password_change_required")
                    ? user?.user?.is_password_change_required === false
                    : true) &&
                  isNextAction === "dashboard" &&
                  showSidebar
                    ? 11
                    : 12
                }
              >
                <Routes>
                  <Route path="/*" element={<Redirect to="/" />} />
                  <Route path="/" element={<Login />} />
                  <Route path="/forget-password" element={<ForgetPassword />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route
                    path="/account-verification"
                    element={<AccountVerify />}
                  />
                  <Route path="/plans" element={<PlanList />} />
                  <Route path="/payments" element={<PaymentInfo />} />
                  <Route path="/activate" element={<AccountActivate />} />
                  <Route path="/feedback" element={<CustomerFeedbackUrl />} />
                  <Route
                    path="/reset-password"
                    element={<AccountResetPassword />}
                  />
                  <Route path="/payment-success" element={<PaymentSuccess />} />
                  <Route path="/customer/*" element={<CustomerOtpLoginPage />} />

                  {isCustomer === true && CustomerRoutes()}
                  {isCustomer === false && superAdminRoutes()}
                </Routes>
                {user?.user?.roles?.includes("CUSTOMER") ||
                user?.user?.roles?.includes("Surveyor") ? (
                  ""
                ) : (
                  <TawkMessengerReact
                    propertyId="6715edca4304e3196ad4ee44"
                    widgetId="1iamqhnii"
                    onLoad={onLoad}
                    ref={tawkMessengerRef}
                  />
                )}
              </Grid>
            </Grid>
          </Router>
        </>
      )}
    </>
  );
};

export default AppRoutes;
